import { useMemo } from 'react';
import debounce from 'lodash/debounce';
import { createDropdown } from '@ott/dropdown-next-deprecated';

import AutocompleteTrigger from './blocks/AutocompleteTrigger/AutocompleteTrigger';
import AutocompleteOverlay from './blocks/AutocompleteOverlay/AutocompleteOverlay';

const ua = typeof window !== 'undefined' && window.navigator.userAgent;
const isIE = ua && (ua.includes('MSIE') || ua.includes('Trident/'));

export const AutocompleteDropdown = createDropdown({
  TriggerComponent: AutocompleteTrigger,
  OverlayComponent: AutocompleteOverlay,
});

export function useDebouncedFunction(onText) {
  // Увеличиваем дебаунс у ие из-за проглатывания букв в геоинпуте
  // при одновременном вводe и получении саджеста
  // Кейс вопроизводился как минимум на Windows 10, IE 11.540

  return useMemo(
    () =>
      debounce(onText, isIE ? 1000 : 100, {
        leading: true,
      }),
    onText
  );
}

export function findActiveOption(text, options) {
  if (!text || !options) {
    return null;
  }

  text = text.toLowerCase();

  return options.find((option) => {
    const name = ((option && option.name) || '').toLowerCase();
    if (name.startsWith(text)) {
      return option;
    }
  });
}

export function checkFullName(activeOption, triggerValue) {
  const activeOptionName = (activeOption && activeOption.name) || '';
  const triggerText = triggerValue || '';
  return activeOptionName && activeOptionName.toLowerCase() === triggerText.toLowerCase();
}
